'use strict';

import './calendar.less'
// 核心
import React from 'react';
// import {EventEmitter} from 'events';
import {extend} from 'jquery'
import classnames from 'classnames';
//
import Component from '../core/component';
import Enhance from '../core/enhance';
// 工具
import tools from '../libs/tools';
// 组件
import Lang from './lang';
import Slider from './slider';
import Lock from '../common/lock'

const {date, time, strtotime, is_int} = tools;

let lang = {
    days: [
        'c.datetime.monday',
        'c.datetime.tuesday',
        'c.datetime.wednesday',
        'c.datetime.thursday',
        'c.datetime.friday',
        'c.datetime.saturday',
        'c.datetime.sunday',
    ],
    months: [
        'c.datetime.january',
        'c.datetime.february',
        'c.datetime.march',
        'c.datetime.april',
        'c.datetime.may',
        'c.datetime.june',
        'c.datetime.july',
        'c.datetime.august',
        'c.datetime.september',
        'c.datetime.october',
        'c.datetime.november',
        'c.datetime.december'
    ],
    monthsShort: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
};

/**
 * 日历
 */
class Calendar extends Component {
    //events = new EventEmitter();
    eventNames = ["Slider"];
    state = {
        year: 0,
        month: 0,
        day: 0,
        datetime: 0,
        max: false,
        min: false,
        format: 'Y-m-d'
    };

    constructor(props, context) {
        super(props, context);
        this.handlerCheck();
        extend(this.state, props);
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        this.refs.YearSelect.value = this.state.year;
        this.refs.MonthSelect.value = this.state.month;
        this.move(`${this.state.year}-${this.state.month}-01`);
    }


    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        extend(this.state, nextProps);
        this.move(`${this.state.year}-${this.state.month}-01`);
    }


    render() {
        return (
            <div className="c-calendar">
                <div className="c-calendar-toolbar">
                    <div className="c-calendar-toolbar-inner">
                        <MonthSelect
                            ref="MonthSelect"
                            onChange={this.handlerMonthClick}
                        />
                        <YearSelect
                            ref="YearSelect"
                            onChange={this.handlerYearClick}
                        />
                    </div>
                </div>
                <div className="c-calendar-inner">
                    <WeekView/>
                    <DaysView
                        max={this.props.max}
                        min={this.props.min}
                        between={this.props.between}
                        ref="DaysView"
                        onValueChange={this.handlerDaysViewChange}
                        onMove={this.handlerDaysMove}
                    />
                </div>
            </div>

        );
    }

    /**
     *
     * @private
     */
    handlerCheck = () => {
        // 时间格式转时间戳
        this.state.datetime = strtotime(this.state.value) || time();

        this.state.year = date('Y', this.state.datetime);//年
        this.state.month = date('m', this.state.datetime);//月
        this.state.day = date('d', this.state.datetime);//日
    }


    /**
     *
     * @param data
     * @private
     */
    handlerDaysViewChange = (data) => {
        this.state.date = date('Y-m-d', data.datetime);
        this.state.month = data.month;
        this.state.year = data.year;
        this.state.day = data.day;
        this.state.datetime = data.datetime;
        this.props.onValueChange && this.props.onValueChange(this.state.date);
    }

    /**
     * 日期移动完成后修改年月的显示
     * @param data
     * @private
     */
    handlerDaysMove = (data) => {
        this.refs.YearSelect.value = data.year;
        this.refs.MonthSelect.value = data.month;
    }


    /**
     * 点击月份
     * @param data
     * @private
     */
    handlerMonthClick = (index) => {
        this.state.datetime = tools.strtotime(`${index} month`, this.state.datetime);
        this.state.year = date('Y', this.state.datetime);
        this.state.month = date('m', this.state.datetime);

        this.refs.YearSelect.value = this.state.year;
        this.refs.MonthSelect.value = this.state.month;
        this.refs.DaysView.sliderMove(this.state.datetime, index);
    }


    /**
     * 点击年份
     * @private
     */
    handlerYearClick = (index) => {
        this.state.datetime = tools.strtotime(`${index} year`, this.state.datetime);
        this.state.year = date('Y', this.state.datetime);
        this.state.month = date('m', this.state.datetime);

        this.refs.YearSelect.value = this.state.year;
        this.refs.DaysView.sliderMove(this.state.datetime, index)
    }


    /**
     *
     */
    get value() {
        if (this.refs.DaysView.selected && this.refs.DaysView.selected.datetime)
            return date(this.state.format, this.refs.DaysView.selected.datetime);
        return '';
    }

    /**
     *
     * @param value
     */
    set value(value) {
        var datetime = strtotime(value) || 0;
        if (datetime > 0) {

            var year = tools.date('Y', datetime);
            var month = tools.date('m', datetime);
            var day = tools.date('d', datetime);

            var index = 0;
            if (year > this.state.year) {
                index++;
            } else if (year < this.state.year) {
                index--;
            } else if (month > this.state.month) {
                index++;
            } else if (month < this.state.month) {
                index--;
            }

            this.state.datetime = datetime;
            this.state.year = year;
            this.state.month = month;
            this.state.day = day;

            this.refs.YearSelect.value = this.state.year;
            this.refs.MonthSelect.value = this.state.month;
            this.refs.DaysView.selected = {year, month, day, datetime};

            this.refs.DaysView.sliderMove(this.state.datetime, index);
        } else {
            this.refs.DaysView.selected = {};
        }
    }

    /**
     *
     * @param year
     * @param month
     */
    move(value) {
        var datetime = strtotime(value) || 0;
        if (datetime > 0) {

            var year = tools.date('Y', datetime);
            var month = tools.date('m', datetime);

            // if (this.state.month == month && this.state.year == year) {
            //     return;
            // }

            var index = 0;
            if (year > this.state.year) {
                index++;
            } else if (year < this.state.year) {
                index--;
            } else if (month > this.state.month) {
                index++;
            } else if (month < this.state.month) {
                index--;
            }

            this.state.datetime = datetime;
            this.state.year = year;
            this.state.month = month;


            this.refs.YearSelect.value = this.state.year;
            this.refs.MonthSelect.value = this.state.month;


            this.refs.DaysView.sliderMove(this.state.datetime, index);
        }
    }

    /**
     *
     * @return {number}
     */
    get year() {
        return this.state.year;
    }

    /**
     *
     * @return {number}
     */
    get month() {
        return this.state.month;
    }

    /**
     *
     * @return {number}
     */
    get day() {
        return this.state.day;
    }
}

/**
 *
 */
class MonthSelect extends Component {
    state = {}

    constructor(props) {
        super(props);
        extend(this.state, props);
    }


    render() {
        return (
            <div className="picker-calendar-month-picker">
                <a href="javascript:;" className="link icon-only picker-calendar-prev-month"
                   onClick={e => {
                       this.handlerClick(-1)
                   }}>
                    <i className="">&lt;</i>
                </a>
                <div className="current-month-value"><Lang lang={lang.months[this.state.month - 1]}/></div>
                <a href="javascript:;" className="link icon-only picker-calendar-next-month"
                   onClick={e => {
                       this.handlerClick(1)
                   }}>
                    <i className="">&gt;</i>
                </a>
            </div>
        );
    }

    /**
     *
     * @param value
     * @private
     */
    handlerClick = (value) => {
        this.props.onChange(value)
    }


    set value(month) {
        this.setState({month}, () => {
        });
    }
}

/**
 *
 */
class YearSelect extends Component {
    state = {}

    constructor(props) {
        super(props);
        extend(this.state, props);
    }


    render() {
        return (
            <div className="picker-calendar-year-picker">
                <a href="javascript:;" className="link icon-only picker-calendar-prev-year"
                   onClick={e => {
                       this.handlerClick(-1)
                   }}>
                    <i className="">&lt;</i>
                </a>
                <span className="current-year-value">
                    <span ref="year-title">{this.state.year}</span>
                    <Lang lang="c.datetime.year"/>
                </span>
                <a href="javascript:;" className="link icon-only picker-calendar-next-year"
                   onClick={e => {
                       this.handlerClick(1)
                   }}>
                    <i className="">&gt;</i>
                </a>
            </div>
        );
    }

    /**
     *
     * @param value
     * @private
     */
    handlerClick = (value) => {
        this.props.onChange(value)
    }


    set value(year) {
        if (year != this.state.year)
            this.setState({year}, () => {
            })
    }
}

/**
 *
 */
class WeekView extends Component {

    constructor() {
        super();
    }

    render() {
        return (
            <div className="c-calendar-week-days">
                {lang.days.map((item, key) => {
                    return (
                        <span key={key} className="c-calendar-week-day">
                            <Lang lang={item}/>
                        </span>
                    );
                })}
            </div>
        )
    }
}

/**
 *
 */
class DaysView extends Component {
    state = {
        selected: null,
        sliderIndex: 0,
        datetime: strtotime(date('Y-m-d', time())),
        s_between: 0,
        e_between: 0
    }


    constructor(props) {
        super(props);
        extend(this.state, props, true);
    }

    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        extend(this.state, nextProps, true);
        this.forceUpdate(() => {
            this.refs.Slider.refresh(0);
        });
    }

    render() {
        return (
            <div className="c-calendar-months">
                <Lock>
                    <Slider
                        ref="Slider"
                        Adapter={this.handlerSliderAdapter}
                        onChange={this.handlerSliderChange}
                    />
                </Lock>
            </div>
        )
    }

    /**
     *
     * @param datetime
     * @param index
     */
    sliderMove(datetime, index) {
        // console.log(date('Y-m-d', datetime));
        //设置提前量
        this.state.sliderIndex += index;

        this.state.datetime = datetime;
        this.state.year = date('Y', datetime);
        this.state.month = date('m', datetime);

        //先刷新下一个
        // this.refs.Slider.refresh(index, () => {
        this.refs.Slider.move({x: index});
        // }, this)
    }


    /**
     * Slider 的适配器动态生成的切换内容
     * @param params
     * @private
     */
    handlerSliderAdapter = (index, x) => {
        // console.log('handlerSliderAdapter', date('Y-m-d', this.state.datetime), index, x);
        var datetime = strtotime(`${index - x} month`, this.state.datetime);
        return this.renderWeeksView(datetime);
    }

    /**
     * 滑动切换 只判断年和月 天是根据用户点击计算的
     * @param data
     * @private
     */
    handlerSliderChange = (data) => {
        if (this.state.sliderIndex > data.x) {
            this.state.datetime = tools.strtotime(`-1 month`, this.state.datetime);
        } else if (this.state.sliderIndex < data.x) {
            this.state.datetime = tools.strtotime(`1 month`, this.state.datetime);
        }
        var year = tools.date('Y', this.state.datetime);
        var month = tools.date('m', this.state.datetime);


        this.props.onMove && this.props.onMove({year, month});
        this.state.sliderIndex = data.x;
    }

    /**
     *
     * @private
     */
    handlerValueChange = (data) => {
        this.refs.Slider && this.refs.Slider.refresh(0);
        this.state.onValueChange && this.state.onValueChange(data);
    }


    /**
     *
     * @param datetime
     * @returns {{Y, m, d, l, W, w, a, A, z, L, t, date: Array}}
     * @private
     */
    getDays(datetime) {

        let days1 = [];
        let days2 = [];
        let days3 = [];

        let year = date('Y', datetime);//年
        let month = date('m', datetime);//月


        // let d = date('d', datetime);//日
        // var l = date('l', datetime);
        // var W = date('W', datetime);//一年内第几周
        // var w = date('w', datetime);//一周内第几天

        // var h = date('h', datetime);//时
        // var i = date('i', datetime);//分
        // var s = date('s', datetime);//秒

        // var a = date('a', datetime);//
        // var A = date('A', datetime);
        // var z = date('z', datetime);//今天是今年的第几天
        // var L = date('L', datetime);//是否闰年

        let m_first_time = strtotime(`${year}-${month}-01 00:00:00`, datetime); //本月第一天
        let t = date('t', m_first_time);//本月共有多少天
        let m_f_w = parseInt(date('w', m_first_time));//本月第一天是周几

        let m_last_time = strtotime(`-1 day`, datetime); //上个月最后一天
        let m_l_t = date('t', m_last_time);//上一个月共多少天


        if (m_f_w == 0) {
            m_f_w = 7
        }

        // 上个月
        for (let i = m_f_w - 1; i > 0; i--) {
            days1.push({
                day: m_l_t - i + 1,
                disabled: true
            });
        }

        var {selected} = this.state;

        var max = strtotime(this.props.max);
        var min = strtotime(this.props.min);

        var betweenMax = false;
        var betweenMin = false;

        if (!tools.empty(this.props.between)) {
            betweenMax = strtotime(this.props.between[0]);
            betweenMin = strtotime(this.props.between[1]);
        }

        //添加日期
        for (var i = 1; i <= t; i++) {


            var value = date('Y-m-d', strtotime(`${i - 1} day`, m_first_time));

            var day = (i < 10 ? '0' : '') + i;

            var data = {
                month,
                year,
                day,
                between: false,
                disabled: false,
                active: false,
                reference: false,
                datetime: strtotime(value)
            };


            //最小日期
            if (min > 0) {
                if (min > data.datetime) {
                    data.disabled = true;
                }
            }

            // 最大日期
            if (max > 0) {
                if (max < data.datetime) {
                    data.disabled = true;
                }
            }

            if (betweenMax > 0 && betweenMin > 0 && betweenMax <= data.datetime && betweenMin >= data.datetime) {
                data.between = true;
            }

            //最小日期
            if (this.props.min !== false) {
                if (this.props.min > data.datetime) {
                    data.disabled = true;
                }
            }

            // 最大日期
            if (this.props.max !== false) {
                if (this.props.max < data.datetime) {
                    data.disabled = true;
                }
            }

            if (!data.disabled && selected) {
                if (selected.year == year
                    && selected.month == month
                    && selected.day == day
                ) {
                    data.active = true;
                } else if (selected.day == day) {
                    data.reference = true;
                }
            }

            //
            days2.push(data);
        }

        var next = 42 - date.length;

        // 下个月
        for (var i = 0; i < next; i++) {
            days3.push({
                day: i + 1,
                disabled: true
            })
        }

        return [].concat(days1, days2, days3);
    }


    /**
     *
     * @param datetime
     * @returns {Array}
     * @private
     */
    renderWeeksView(datetime) {
        var days = this.getDays(datetime);
        var views = [];
        for (var i = 0; i < 6; i++) {
            views.push(
                <div key={i} className="c-calendar-row">
                    {this.renderWeekDayView(days, i)}
                </div>
            )
        }
        return (
            <div key={tools.date('Y-m', datetime)} style={{height: '100%'}}>
                {views}
            </div>
        );
    }

    /**
     *
     * @param days
     * @param index
     * @returns {Array}
     * @private
     */
    renderWeekDayView(days, index) {
        var start = index * 7;
        var views = [];
        for (var i = start; i < start + 7; i++) {
            var day = days[i];
            views.push(
                <span
                    key={i}
                    className={classnames('c-calendar-day', {
                        'c-calendar-day-prev': day.disabled,
                        'hover': !day.disabled,
                        'c-day-selected': day.active,
                        'c-day-reference': day.reference,
                        'c-day-between': day.between
                    })}
                    onClick={!day.disabled ? () => {
                        this.handlerClick({
                            year: day.year,
                            month: day.month,
                            day: day.day,
                            datetime: day.datetime
                        })
                    } : null}
                    data-year={day.year}
                    data-month={day.month}
                    data-day={day.day}
                >
                    <span>{day.day}</span>
                </span>
            )
        }
        return views;
    }

    /**
     *
     * @param day
     * @private
     */
    handlerClick = (selected) => {
        this.setState({selected}, () => {
            this.handlerValueChange(selected)
        });

    }

    /**
     *
     * @param selected
     */
    set selected(selected) {
        this.setState({selected}, () => {
            this.refs.Slider && this.refs.Slider.refresh(0);
        });
    }

    /**
     *
     * @returns {null}
     */
    get selected() {
        return this.state.selected;
    }
}

MonthSelect.displayName = "MonthSelect";
YearSelect.displayName = "YearSelect";
WeekView.displayName = "WeekView";
DaysView.displayName = "DaysView";
Calendar.displayName = "Calendar";
export default Calendar;
